import { BASE_URL } from "./constant";

const API_BASE = (process.env.REACT_APP_API_BASE || BASE_URL || "").replace(/\/+$/, "");

function buildUrl(path, params = {}) {
  const url = new URL(`${API_BASE}${path}`);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

async function request(path, options = {}) {
  const response = await fetch(buildUrl(path, options.params), {
    method: options.method || "GET",
    headers: options.body ? { "Content-Type": "application/json" } : undefined,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.error || "Erreur de chargement Direct");
  }

  return payload.data ?? payload;
}

export function buildLiveMediaUrl(path) {
  if (!path) {
    return `${process.env.PUBLIC_URL}/images/bg.png`;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

export async function fetchLiveFeed() {
  return request("/api/live/feed");
}

export async function fetchLiveChannels(params = {}) {
  return request("/api/live/channels", { params });
}

export async function fetchLiveChannel(id) {
  return request(`/api/live/channels/${id}`);
}

export async function requestLivePlayback(id, mode = "direct") {
  return request(`/api/live/channels/${id}/playback`, {
    method: "POST",
    body: { mode },
  });
}

export async function importFreeLiveChannels(options = {}) {
  return request("/api/live/admin/import/free", {
    method: "POST",
    body: options,
  });
}

export async function saveLiveChannel(payload) {
  return request("/api/live/admin/channels", {
    method: "POST",
    body: payload,
  });
}

export async function updateLiveChannel(id, payload) {
  return request(`/api/live/admin/channels/${id}`, {
    method: "PUT",
    body: payload,
  });
}

export async function deleteLiveChannel(id) {
  return request(`/api/live/admin/channels/${id}`, {
    method: "DELETE",
  });
}
